angular.module("vgresiduos").component("loginWithTokenRedirect", {
	controller: "LoginWithTokenRedirectCtrl",
	templateUrl:
		"views/afterLoginIdentityProvider/components/loginWithTokenRedirect/loginWithTokenRedirect_template.html",
	bindings: {}
});
